<script setup lang="ts">
import { StateOfAutocomplete } from '@/constants/components/autocomplete'

import { useAppStore } from '@/store/app/app'
import { useDeliveryStore } from '@/store/delivery/delivery'
import { PlacesSearch } from '@/store/delivery/delivery.types'

import { ServerError, Success } from '@/api/results'

const emits = defineEmits(['setAutocompleteError'])

const myPositionIsLoading = ref(false)
const isDisabledButton = shallowRef(true)

const { $sentryCaptureException } = useNuxtApp()

const { showSnackbar } = useAppStore()
const deliveryStore = useDeliveryStore()

onMounted(() => {
  if (navigator.geolocation) isDisabledButton.value = !isDisabledButton
})

// Запрашиваем геопозицию клиента
const getMyPosition = (): any => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Геолокация не поддеживается вашим браузером'))
    }
    navigator.geolocation.getCurrentPosition(resolve, reject)
  })
}

// Получаем геопозицию клиента
const geolocationClickHandler = async () => {
  myPositionIsLoading.value = true

  try {
    const { coords } = await getMyPosition()

    const { latitude, longitude } = coords

    const { $apiService } = useNuxtApp()

    const result = await $apiService.geocode.getAddressByCoordinates([
      latitude,
      longitude,
    ])

    if (result instanceof ServerError) {
      emits('setAutocompleteError', StateOfAutocomplete.NOT_DETECTED)

      return
    }

    const address = result instanceof Success ? result.data : null

    // Передаем autocomplete, т.к нужно обновить состояние других компонентов
    deliveryStore.setDeliverySearch(PlacesSearch.AUTOCOMPLETE, address)
  } catch (error) {
    const errorMessage =
      error.code === 1
        ? StateOfAutocomplete.BAN_GEO
        : StateOfAutocomplete.NOT_DETECTED

    showSnackbar({ message: errorMessage })

    $sentryCaptureException(error)
  }

  myPositionIsLoading.value = false
}
</script>

<template>
  <the-button
    icon="navigation"
    :loading="myPositionIsLoading"
    :disabled="isDisabledButton"
    variant="primary"
    size="sm"
    :icon-size="18"
    @click="geolocationClickHandler"
  />
</template>
